import BaseLayout from '@/components/PageLayout';
import BackToBottom from '@/components/PageLayout/BackToBottom';
import { getBlogTheTemp } from '@elem/compBlog/blog-common/getBlogTheTemp';
import '@elem/compBlog/blog.scss';
import '@elem/compBlog/details/blog-delta.scss';
import BlogDetailsCatalog from '@elem/compBlog/details/delta-catalog';
import BlogDetailsTop from '@elem/compBlog/details/delta-top';
import EfImg from '@elem/ui/ef-img';
import SeoCommon from 'lowcode/common/SeoCommon';
import ProductBlog from 'lowcode/pages/product-blog';
import { queryEditorDetailBlogOnline } from 'lowcode/utils/service';
import { queryIndexCategoryItems } from 'lowcomp/plugins/blog/common/blog-editor-api/queryIndexCategoryItems';
import { getRedirectUrlHandle } from 'lowcomp/plugins/blog/common/utils';
import Head from 'next/head';
import { useEffect, useRef, useState } from 'react';
import './blog-detail.scss';

const hostName = process.env.NEXT_PUBLIC_WEB_HOST;

export default function Page({ tempData1, tempDataGloConfig,tempDataBottom, locale, id, id_glo_config }: any) {
    // const [showBackToBottom, setShowBackToBottom] = useState(false);
    const tempData2 = getBlogTheTemp(tempData1);
    const tempDataA1 = JSON.parse(JSON.stringify(tempData1)); //内存溢出不少,可能是不多的组件共用同一份数据
    const tempDataA2 = JSON.parse(JSON.stringify(tempData1));
    const tempDataA3 = JSON.parse(JSON.stringify(tempData1));
    const { thePage = {} } = tempDataA1;
    const canonicalHref = hostName ? `${hostName}${id}` : id;
    const { isHideBlogMainImg = 'false', blogImgPc, blogImgH5 } = thePage;
    const isHideBlogMainImg2 = `${isHideBlogMainImg}`;

    // useEffect(() => {
    //     const timer = setTimeout(() => {
    //         setShowBackToBottom(true);
    //     }, 10000); // 10秒后显示

    //     return () => {
    //         clearTimeout(timer);
    //     };
    // }, []);
    const catalogRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const updateStickyOffset = () => {
            let totalHeight = 12;

            const header = document.querySelector('.ecoflow-frame-header');
            if (header) {
                totalHeight += header.getBoundingClientRect().height;
            }
            if (catalogRef.current) {
                catalogRef.current.style.setProperty('--blog-delta-sticky-top-offset', `${totalHeight}px`);
            }
        };

        updateStickyOffset();

        window.addEventListener('resize', updateStickyOffset);
        return () => window.removeEventListener('resize', updateStickyOffset);
    }, []);
    return (
        <BaseLayout>
            <Head>
                <link rel="canonical" href={canonicalHref} />
            </Head>
            <SeoCommon title={thePage.seoTitle} description={thePage.seoDescription} titleTemplate="%s" />
            <div className="blog-delta-top-wrapper">
                <BlogDetailsTop tempData={tempDataA2} locale={locale} />
            </div>
            <div className="blog-delta" ref={catalogRef}>
                <div className="blog-delta-l-side">
                    <BlogDetailsCatalog tempData={tempDataA1} locale={locale} />
                </div>
                <div className="blog-delta-r-side">
                    {isHideBlogMainImg2 !== 'true' && !!blogImgPc && (
                        <div className="blog-delta-top-img">
                            <EfImg pc={blogImgPc} h5={blogImgH5} />
                        </div>
                    )}
                    {/* <BlogDetailsCatalog tempData={tempDataA1} locale={locale} /> */}
                    <div className="blog-delta-content">
                        <ProductBlog id={id} data={tempData2} />
                    </div>
                </div>
                <div className="blog-delta-rr-side">
                    <ProductBlog id={id_glo_config} data={tempDataGloConfig} />
                    {['us'].includes(locale) && (
                        <div className="blog-side-support">
                            <div className="split-line"></div>
                            <p className="support-label">For press requests or interview opportunities, reach out to our media team</p>
                            <a className="support-mail" href="mailto:media.na@ecoflow.com">
                                <span>media.na@ecoflow.com</span>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M5.66797 3.66406L10.0013 7.9974L5.66797 12.3307"
                                        stroke="currentColor"
                                        stroke-width="1.06667"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            </a>
                        </div>
                    )}
                </div>
            </div>
            <div className="blog-delta-bottom">
               <ProductBlog id={`blog-bottom`} data={tempDataBottom} />
            </div>
        </BaseLayout>
    );
}

export async function getServerSideProps({ params, pathname, locale }: any) {
    const id1 = params.id[0];
    const id = `/${locale}/blog/${id1}`;
    const id_glo_config = `/${locale}/blog/__blog_config_data_a`;
    const tempData1: any = await queryEditorDetailBlogOnline(id, locale);
    // const tempDataGloConfig: any = await queryEditorDetailBlogOnline(id_glo_config, locale);

    // 缓存广告位数据
    const tempDataGloConfig = await fetch(`${hostName}/api/getBlogAdsOnline?locale=${locale}&id=${id_glo_config}`);
    const adsData = await tempDataGloConfig?.json();

    const tempDataA: any = await queryIndexCategoryItems(locale, tempData1);
    const tempDataBottom: any = {};

    // 处理数据：把 tData 中 theTemp 里 name 为 BlogCategoryA 的模块迁移到 adData 中，
    // 并且把对应 id 的 theData / theAttr 一并迁移过去（原地修改，不返回新对象）
    const handleData = (tData: any, adData: any,tempName:string) => {
        if (!tData) {
            return;
        }

        if (!adData) {
            adData = {};
        }

        const sourceTemp = Array.isArray(tData.theTemp) ? tData.theTemp : [];
        const targetTemp = Array.isArray(adData.theTemp) ? adData.theTemp : (adData.theTemp = []);

        const sourceData = tData.theData || {};
        const targetData = adData.theData || (adData.theData = {});

        const sourceAttr = tData.theAttr || {};
        const targetAttr = adData.theAttr || (adData.theAttr = {});

        const remainTemp: any[] = [];

        sourceTemp.forEach((item: any) => {
            if (item?.name === tempName && item?.id) {
                // 模板项迁移到广告数据中
                targetTemp.push(item);

                // theData 中对应的数据迁移
                if (Object.prototype.hasOwnProperty.call(sourceData, item.id)) {
                    targetData[item.id] = sourceData[item.id];
                    delete sourceData[item.id];
                }

                // theAttr 中对应的数据迁移（如果有）
                if (Object.prototype.hasOwnProperty.call(sourceAttr, item.id)) {
                    targetAttr[item.id] = sourceAttr[item.id];
                    delete sourceAttr[item.id];
                }
            } else {
                remainTemp.push(item);
            }
        });

        tData.theTemp = remainTemp;
        tData.theData = sourceData;
        tData.theAttr = sourceAttr;
    };

    // 原地修改 tempData 和 tempDataGloConfig
    handleData(tempDataA, tempDataBottom, 'BlogCategoryA');
    handleData(tempDataA, adsData.data, 'BlogZJoinEmail');
    // 页面重定向
    const redirectUrl = getRedirectUrlHandle(tempDataA?.sqlData?.redirectUrl, id);
    if (redirectUrl) {
        return {
            redirect: {
                destination: redirectUrl, // 目标页面路径
                statusCode: 301,
            },
        };
    }

    if (tempData1.haveNoneDataFlag) {
        return {
            redirect: {
                destination: `/${locale}/blog`, // 目标页面路径
                statusCode: 301,
            },
        };
    }
    return {
        props: {
            tempData1: tempDataA,
            id_glo_config,
            tempDataGloConfig: adsData?.data || {},
            tempDataBottom: tempDataBottom || {},
            locale,
            id,
        },
    };
}
